// export const BASE_URL = 'http://localhost:5002/api/';
export const BASE_URL = 'https://apitest.sendforsign.com/api/';
// export const BASE_URL = 'https://api.sendforsign.com/api/';

export const SHARE_URL = `https://app.sendforsign.com`; 
